<!-- VIP客服绑定页 -->
<template>
  <div class="vip-service">
    <!-- 加载中 -->
    <div v-if="!step" class="loading-wrap">
      <van-loading type="spinner" color="#565ade" size="36px">正在为您匹配游戏顾问...</van-loading>
    </div>

    <!-- PAGE1 前置选择 -->
    <template v-if="step === 'select'">
      <div class="select-card">
        <p class="select-title bold">请确认您的游戏类型</p>
        <div class="select-options">
          <label class="radio-item" @click="gameType = 'minigame'">
            <span class="radio-circle" :class="{ active: gameType === 'minigame' }">
              <span class="radio-dot" v-if="gameType === 'minigame'"></span>
            </span>
            <span>小程序</span>
          </label>
          <label class="radio-item" @click="gameType = 'app'">
            <span class="radio-circle" :class="{ active: gameType === 'app' }">
              <span class="radio-dot" v-if="gameType === 'app'"></span>
            </span>
            <span>应用</span>
          </label>
        </div>
      </div>
      <van-button
        class="confirm-btn"
        round
        block
        color="linear-gradient(61deg, #658dfd 0%, #565ade 100%)"
        @click="onConfirmType"
      >
        确认
      </van-button>
    </template>

    <!-- PAGE2 表单页 -->
    <template v-if="step === 'form'">
      <div class="form-section">
        <p class="tip-text">{{ leadContent || '填写id 为您匹配游戏顾问' }}</p>
        <!-- <p class="form-guide">
          输入<span class="highlight bold">{{ isApp ? '角色ID/账号：' : '角色ID：' }}</span>为您匹配账号信息：
        </p> -->

        <div class="form-item">
          <label class="form-label">{{ isApp ? '角色ID/账号：' : '角色ID：' }}</label>
          <input
            class="form-input"
            type="text"
            v-model="roleId"
            placeholder="请输入"
          />
        </div>

        <van-button
          class="match-btn"
          round
          block
          color="linear-gradient(61deg, #658dfd 0%, #565ade 100%)"
          :loading="matchLoading"
          @click="onMatch"
        >
          匹配游戏顾问
        </van-button>
      </div>

      <!-- 引导图 -->
      <div class="guide-section">
        <div class="guide-title">
          <span class="guide-text">如何获取信息？参考下方图示</span>
        </div>
        <div class="guide-images">
          <div class="guide-placeholder" v-if="!guideImage">
            <p>引导图片占位</p>
          </div>
          <img v-else class="guide-img" :src="guideImage" alt="引导图" />
        </div>
      </div>
    </template>

    <!-- PAGE3 匹配成功 - 展示客服二维码 -->
    <template v-if="step === 'success'">
      <div class="form-section">
        <p class="tip-text">{{ leadContent || '填写id 为您匹配游戏顾问' }}</p>
        <!-- <p class="form-guide">
          输入<span class="highlight bold">{{ isApp ? '角色ID/账号：' : '角色ID：' }}</span>为您匹配账号信息：
        </p> -->

        <div class="form-item">
          <label class="form-label">{{ isApp ? '角色ID/账号：' : '角色ID：' }}</label>
          <input class="form-input matched" type="text" :value="roleId" disabled />
        </div>

        <van-button
          class="match-btn"
          round
          block
          color="linear-gradient(61deg, #658dfd 0%, #565ade 100%)"
          disabled
        >
          匹配游戏顾问
        </van-button>
      </div>

      <div class="qr-section">
        <p class="qr-title">扫码匹配游戏顾问</p>
        <div class="qr-code">
          <div class="qr-placeholder" v-if="!qrCodeUrl">
            <p>客服二维码占位</p>
          </div>
          <img v-else class="qr-img" :src="qrCodeUrl" alt="客服二维码" />
        </div>
      </div>
    </template>

    <!-- PAGE4 匹配失败弹窗 -->
    <van-overlay :show="showFailDialog" @click="showFailDialog = false">
      <div class="fail-dialog" @click.stop>
        <div class="fail-header">
          <span class="fail-title bold">系统提示</span>
          <van-icon name="cross" class="fail-close" @click="showFailDialog = false" />
        </div>
        <div class="fail-body">
          <p>暂未找到游戏顾问,您可重新输入信息匹配或联系在线客服</p>
        </div>
        <div class="fail-footer">
          <van-button
            class="fail-btn"
            round
            color="#e0e0e0"
            @click="onRetryMatch"
          >
            <span style="color: #666;">重新匹配</span>
          </van-button>
          <van-button
            class="fail-btn"
            round
            color="linear-gradient(61deg, #658dfd 0%, #565ade 100%)"
            @click="onContactService"
          >
            联系在线客服
          </van-button>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Button, Icon, Overlay, Toast, Loading } from 'vant'
import {
  getVipInitial,
  getVipGameOptions,
  findVipCustomer,
} from '@/apis/gameJump'
import track from './components/track'

// 在线客服地址
const SERVICE_URL_MAP = {
  // APP普客（玩心）
  app_wanxin: 'https://tb.53kf.com/code/app/10236926/9',
  // APP普客（悦玩，仅太古传奇）
  app_yuewan: 'https://tb.53kf.com/code/app/8cb266316622574c8335adf4435c88eb4/2',
  // 小程序普客
  minigame: 'https://work.weixin.qq.com/kfid/kfcc0368b8c43a4e240',
}
// 缓存 key
const CACHE_KEY = 'vip_service_match_result'


export default {
  mixins: [track],
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Overlay.name]: Overlay,
    [Loading.name]: Loading,
  },
  data() {
    return {
      step: '',
      gameType: 'minigame',
      // 初始信息
      leadContent: '',
      appLeadImage: '',
      minigameLeadImage: '',
      // 表单
      roleId: '',
      selectedGame: null,
      // 轮询定时器
      pollTimer: null,
      // 匹配
      matchLoading: false,
      qrCodeUrl: '',
      showFailDialog: false,
    }
  },
  computed: {
    query() {
      return this.$route.query || {}
    },
    isApp() {
      return this.gameType === 'app'
    },
    // 接口 type 参数
    typeParam() {
      return this.isApp ? 'app' : 'minigame'
    },
    // 根据类型展示对应引导图
    guideImage() {
      return this.isApp ? this.appLeadImage : this.minigameLeadImage
    },
    // 页面类型中文（埋点用）
    pageTypeLabel() {
      if (this.step === 'select') return '前置选择页'
      return this.isApp ? 'APP' : '小程序'
    },
  },
  watch: {
    // 页面曝光埋点
    step(val) {
      if (val === 'select' || val === 'form') {
        this.buryReport('VIP_CUSTOMER_PAGE_SHOW', {
          type: this.pageTypeLabel,
        })
      }
    },
    // 失败弹窗曝光埋点
    showFailDialog(val) {
      if (val) {
        const raw = this.selectedGame?._raw || {}
        this.buryReport('VIP_CUSTOMER_FIND_FAIL_SHOW', {
          type: this.pageTypeLabel,
          role_id: raw.role_id || this.roleId,
          appkey: raw.appkey,
        })
      }
    },
  },
  created() {
    // const cache = this.loadCache()
    // if (cache) {
    //   // 有缓存，step 保持空白不渲染，等接口返回再展示
    //   this.gameType = cache.gameType
    //   this.roleId = cache.roleId
    //   this.selectedGame = cache.selectedGame
    //   this.fetchInitial()
    //   this.reMatch(cache.selectedGame)
    //   return
    // }
    const { game_type } = this.query
    this.gameType = game_type === 'minigame' ? 'minigame' : 'app'
    this.step = 'form'
    this.fetchInitial()
  },
  beforeDestroy() {
    clearTimeout(this.pollTimer)
  },
  methods: {
    // 确认游戏类型
    onConfirmType() {
      // 确定按钮点击埋点
      this.buryReport('VIP_CUSTOMER_PAGE_CLICK', {
        type: '前置选择页',
        chose_type: this.isApp ? 'APP' : '小程序',
      })
      this.step = 'form'
      this.fetchInitial()
    },

    // 获取初始信息
    async fetchInitial() {
      try {
        const res = await getVipInitial({
          time: Math.floor(Date.now() / 1000),
        })
        if (res.ret === 1) {
          const { lead_content, app_lead_image, minigame_lead_image } = res.content
          this.leadContent = lead_content || ''
          this.appLeadImage = app_lead_image || ''
          this.minigameLeadImage = minigame_lead_image || ''
        }
      } catch (e) {
        console.log('fetchInitial error', e)
      }
    },

    // 匹配专属客服
    async onMatch() {
      if (!this.roleId.trim()) {
        Toast('请输入角色ID')
        return
      }
      if (this.matchLoading) return
      this.matchLoading = true
      try {
        // 先获取游戏选项
        const res = await getVipGameOptions({
          time: Math.floor(Date.now() / 1000),
          type: this.typeParam,
          value: this.roleId.trim(),
        })
        if (res.ret !== 1 || !res.content.game_options?.length) {
          Toast('未找到匹配的游戏信息，请检查角色ID')
          this.matchLoading = false
          return
        }
        // 取第一个游戏选项
        const firstGame = res.content.game_options[0]
        this.selectedGame = { text: firstGame.app_name, _raw: firstGame }
        // 埋点
        this.buryReport('VIP_CUSTOMER_FIND_CUSTOMER_CLICK', {
          role_id: firstGame.role_id,
          appkey: firstGame.appkey,
        })
        // 匹配客服
        await this.doFindCustomer(this.selectedGame, true)
      } catch (e) {
        console.log('onMatch error', e)
        Toast('匹配失败，请重试')
        this.matchLoading = false
      }
    },

    // 执行匹配请求，showFail 控制失败时是否弹窗
    async doFindCustomer(game, showFail = true) {
      const raw = game._raw
      try {
        const res = await findVipCustomer({
          time: Math.floor(Date.now() / 1000),
          type: this.isApp ? 'app' : 'minigame',
          role_type: raw.role_type,
          user_id: raw.user_id,
          appkey: raw.appkey,
          role_id: raw.role_id,
        })
        if (res.ret === 1) {
          const { status, qr_code_url } = res.content
          if (status === 1 && qr_code_url) {
            this.qrCodeUrl = qr_code_url
            this.step = 'success'
            this.matchLoading = false
            // this.saveCache()
            return 'success'
          } else if (status === 2) {
            // 匹配客服中，3s后重试
            return new Promise(resolve => {
              this.pollTimer = setTimeout(async () => {
                const result = await this.doFindCustomer(game, showFail)
                resolve(result)
              }, 3000)
            })
          } else {
            this.matchLoading = false
            if (showFail) this.showFailDialog = true
            return 'fail'
          }
        } else {
          this.matchLoading = false
          if (showFail) this.showFailDialog = true
          return 'fail'
        }
      } catch (e) {
        console.log('findVipCustomer error', e)
        this.matchLoading = false
        if (showFail) this.showFailDialog = true
        return 'fail'
      }
    },

    // 重新匹配
    onRetryMatch() {
      const raw = this.selectedGame?._raw || {}
      this.buryReport('VIP_CUSTOMER_FIND_FAIL_CLICK', {
        type: this.pageTypeLabel,
        role_id: raw.role_id || this.roleId,
        appkey: raw.appkey,
      })
      this.showFailDialog = false
      this.roleId = ''
      this.selectedGame = null
    },

    // 联系在线客服
    onContactService() {
      const raw = this.selectedGame?._raw || {}
      this.buryReport('VIP_CUSTOMER_FIND_FAIL_CLICK', {
        type: this.pageTypeLabel,
        role_id: raw.role_id || this.roleId,
        appkey: raw.appkey,
      })
      let url
      if (this.isApp) {
        url = raw.role_type === 'yuewan'
          ? SERVICE_URL_MAP.app_yuewan
          : SERVICE_URL_MAP.app_wanxin
      } else {
        url = SERVICE_URL_MAP.minigame
      }
      window.open(url, '_self')
    },

    // 用缓存数据重新请求匹配
    async reMatch(game) {
      const result = await this.doFindCustomer(game, false)
      if (result !== 'success') {
        this.clearCache()
        this.step = 'form'
      }
    },

    // 缓存选中的角色和游戏信息
    saveCache() {
      try {
        localStorage.setItem(CACHE_KEY, JSON.stringify({
          gameType: this.gameType,
          roleId: this.roleId,
          selectedGame: this.selectedGame,
        }))
      } catch (e) {
        console.log('saveCache error', e)
      }
    },

    // 读取缓存
    loadCache() {
      try {
        const raw = localStorage.getItem(CACHE_KEY)
        if (!raw) return null
        return JSON.parse(raw)
      } catch (e) {
        return null
      }
    },

    // 清除缓存
    clearCache() {
      localStorage.removeItem(CACHE_KEY)
    },
  },
}
</script>

<style lang="scss" scoped>
.vip-service {
  min-height: 100vh;
  padding: 16px;
  background-color: #f5f5f5;
}

// PAGE1 前置选择
.select-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px 20px;
  margin-bottom: 24px;

  .select-title {
    font-size: 16px;
    color: #333;
    margin-bottom: 20px;
  }

  .select-options {
    .radio-item {
      display: flex;
      align-items: center;
      padding: 12px 0;
      font-size: 14px;
      color: #333;
      cursor: pointer;

      .radio-circle {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 2px solid #ccc;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s;

        &.active {
          border-color: #565ade;
        }

        .radio-dot {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #565ade;
        }
      }
    }
  }
}

.confirm-btn {
  margin-top: 8px;
}

// PAGE2 表单
.form-section {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;

  .tip-text {
    font-size: 14px;
    color: #666;
    margin-bottom: 12px;
  }

  .form-guide {
    font-size: 14px;
    color: #333;
    margin-bottom: 16px;

    .highlight {
      color: #565ade;
    }
  }

  .form-item {
    display: flex;
    align-items: center;
    margin-bottom: 14px;

    .form-label {
      font-size: 14px;
      color: #333;
      white-space: nowrap;
      margin-right: 8px;
    }

    .form-input {
      flex: 1;
      width: 0;
      font-size: 14px;
      padding: 8px 12px;
      border-radius: 4px;
      border: 1px solid #ddd;
      color: #333;
      background-color: #fff;

      &:focus {
        border-color: #565ade;
      }

      &.matched {
        background-color: #f0f0f0;
        color: #565ade;
        border-color: #565ade;
      }
    }

  }

  .match-btn {
    margin-top: 8px;
  }
}

// 引导图区域
.guide-section {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;

  .guide-title {
    font-size: 14px;
    color: #000;
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    position: relative;

    .guide-text {
      position: relative;
      display: inline-block;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 9px;
        background: rgba(101, 141, 253, 0.38);
        border-radius: 4.5px;
        z-index: 0;
      }
    }
  }

  .guide-images {
    .guide-placeholder {
      width: 100%;
      height: 200px;
      background: #f5f5f5;
      border: 1px dashed #ddd;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #999;
      border-radius: 4px;
    }

    .guide-img {
      width: 100%;
      border-radius: 4px;
    }
  }
}

// PAGE3 二维码区域
.qr-section {
  background: #fff;
  border-radius: 12px;
  padding: 20px 16px;
  text-align: center;

  .qr-title {
    font-size: 15px;
    color: #333;
    margin-bottom: 16px;
    font-weight: bold;
  }

  .qr-code {
    display: flex;
    justify-content: center;

    .qr-placeholder {
      width: 200px;
      height: 200px;
      background: #f5f5f5;
      border: 1px dashed #ddd;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #999;
      border-radius: 4px;
    }

    .qr-img {
      width: 200px;
      height: 200px;
    }
  }
}

// PAGE4 匹配失败弹窗
.fail-dialog {
  width: 300px;
  background: #fff;
  border-radius: 12px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;

  .fail-header {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 14px 16px;
    background: linear-gradient(61deg, #658dfd 0%, #565ade 100%);

    .fail-title {
      font-size: 17px;
      color: #fff;
    }

    .fail-close {
      position: absolute;
      right: 16px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 20px;
      color: #fff;
    }
  }

  .fail-body {
    padding: 28px 24px 28px;
    text-align: center;
    font-size: 15px;
    color: #333;
    line-height: 1.7;
  }

  .fail-footer {
    display: flex;
    padding: 0 16px 20px;
    gap: 12px;

    .fail-btn {
      flex: 1;
      height: 40px;
    }
  }
}

// 加载中
.loading-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
}

// 公共
.bold {
  font-weight: bold;
}
</style>
